"use client"

import { useEffect } from "react"
import toast from "react-hot-toast"

import { cartServiceClient } from "#modules/cart/services/cart.client.service"
import { useTranslation } from "#modules/localization/translations.client"

export function CartLoadErrorNotification() {
  const { t } = useTranslation("cp/cart")

  const message = t("errorLoadingCart")

  useEffect(() => {
    // If message is not loaded yet, return
    //@ts-ignore
    if (message === "errorLoadingCart") return
    if (cartServiceClient.getCartHash()) {
      cartServiceClient.resetCartHash()
      toast.error(t("errorLoadingCart"), {
        position: "top-right",
        style: { backgroundColor: "#ef4444", color: "white" },
      })
    }
  }, [message])
  return null
}
